import * as FileSaver from 'file-saver'
import debug from 'Helper/debugHelpers'
import { call } from 'redux-saga/effects'
import { download } from 'Helper/xtract_api'
import checkResult from './checkResult'
import { APIsetup } from './xtractAPISagas'
import { errorHandlers } from '../XtractAPI.jsx'

export default function* doXtractFileDownload(action) {
  const setup = yield call(APIsetup, action)
  let { filename = 'filename', config = {} } = action
  const { token, resource, transaction } = setup
  let result
  debug.log(
    'making a csv download API call to ' + resource,
    debug.logLevels.API
  )
  try {
    result = yield call(
      [this, download],
      token,
      resource,
      transaction,
      action.config.contentType
    )
  } catch (error) {
    debug.log('error: ' + error, debug.logLevels.API, 'error')

    return null
  }
  filename = result.filename ? result.filename : filename

  if (action.callbacks.error == null) {
    action.callbacks.error = function* () {
      yield call(
        [this, errorHandlers.defaultDownloadErrorHandler],
        filename,
        ...arguments
      )
    }
  }
  result = yield call(checkResult, result, action)
  if (result != null && !config.skipDownload) {
    FileSaver.saveAs(result, filename)
  }
}
